module.exports = __webpack_public_path__ + "static/media/SparkleIcon.4425308f.svg";